import React from 'react';
import { Instant } from '../utility/datetime';
export const useNow = (frequency) => {
    const [stateNow, setNow] = React.useState(Instant.now());
    React.useEffect(() => {
        const interval = window.setInterval(() => setNow(Instant.now()), frequency || 250);
        return () => window.clearInterval(interval);
    }, [frequency]);
    return stateNow;
};
export default useNow;
